import { ObjectUtils } from "../../utils/ObjectUtils";

export class Relator {
    nome: string = '';
    sigla: string = '';

    static novo(partial: Partial<Relator>): Relator {
        return ObjectUtils.assign(new Relator(), partial);
    }

}